const { breakpoints } = require('site/components/functions');
const { alert } = require('site/components/alerts');
const scrollAnimate = require('base/components/scrollAnimate');
const formValidation = require('base/components/formValidation');
const carouselAnimations = require('../components/carouselAnimations');
const validateAddress = require('../addressBook/validateAddress');
var cleave = require('base/components/cleave');

const formFields = [
    'input[name$=_email]',
    'input[name$=_firstName]',
    'input[name$=_lastName]',
    'input[name$=_address1]',
    'input[name$=_address2]',
    'input[name$=_city]',
    'input[name$=_postalCode]',
    'input[name$=_phone]',
];

const formSelect = [
    'select[name$=_stateCode]',
    'select[name$=_country]',
];

function updateSummaryPackMessage() {
    let name;
    let amount;
    const clubSelectedOption = $('.js-club-select option:selected');

    if (clubSelectedOption.length > 0) {
        const wineClubClass = `.js-club-${clubSelectedOption.val()}`;
        const $selectedOption = $(wineClubClass).find('.js-bottles-option.active');
        name = $selectedOption.data('club-name');
        amount = $selectedOption.data('club-amount');
    } else {
        name = $('.js-bottles-option.active').data('club-name');
        amount = $('.js-bottles-option.active').data('club-amount');
    }
    $('.js-summary-pack-name').html(name);
    $('.js-summary-pack-frequency').html(amount);
}

function updateClubHiddenInputs() {
    const clubSelectedOption = $('.js-club-select option:selected');
    if (clubSelectedOption.length > 0) {
        const wineClubClass = `.js-club-${clubSelectedOption.val()}`;
        const $selectedPackOption = $(wineClubClass).find('input:radio:checked');
        $('.js-pack-type').val($selectedPackOption.val());
        $('.js-club').val(clubSelectedOption.val());
    }
}

function handleBottles() {
    $('.js-bottles-option').each(function () {
        $(this).toggleClass('active', $(this).find('input:radio').prop('checked'));
    });
    updateClubHiddenInputs();
    updateSummaryPackMessage();
}

function checkOption() {
    const $input = $(this).find('input:radio').first();
    if (!$input.prop('checked')) {
        $input.prop('checked', true).trigger('change');
    }
}

function clearPasswordFields() {
    $('#password').val('');
    $('#passwordconfirm').val('');
}

function removePasswordFields() {
    $('.js-billing-account').addClass('d-none');
    clearPasswordFields();
}

function displayPasswordFields() {
    if ($('.js-is-registered').length > 0) return;

    const email = $(this).val();
    if (!email || !this.checkValidity()) {
        removePasswordFields();
    } else {
        $.spinner().start();
        const $form = $(this).closest('form');

        $.ajax({
            url: $(this).data('url-verify'),
            type: 'POST',
            dataType: 'json',
            data: $form.serialize(),
        })
            .done((data) => {
                clearPasswordFields();
                if (data.success) {
                    if (data.removePasswords) {
                        removePasswordFields();
                    } else if (data.existingCustomer) {
                        $('.js-passwordconfirm').addClass('d-none');
                        $('.js-password-constraints').addClass('d-none');
                        $('.js-billing-account').removeClass('d-none');
                        $('.js-guest-disclaimer').addClass('d-none');
                        $('.js-registered-disclaimer').removeClass('d-none');
                        $('#passwordconfirm').attr('disabled', true);
                    } else {
                        $('.js-passwordconfirm').removeClass('d-none');
                        $('.js-password-constraints').removeClass('d-none');
                        $('.js-billing-account').removeClass('d-none');
                        $('.js-guest-disclaimer').removeClass('d-none');
                        $('.js-registered-disclaimer').addClass('d-none');
                        $('#passwordconfirm').removeAttr('disabled');
                    }
                    if (data.customerEmail) {
                        $('.js-customer-email').html(data.customerEmail);
                    }
                }
            })
            .always(() => {
                $.spinner().stop();
            });
    }
}

function updateSummaryAddress(addressType, shippingAddress) {
    const firstName = $(`[name*=dwfrm_membership_${addressType}Address_firstName]`).val();
    const lastName = $(`[name*=dwfrm_membership_${addressType}Address_lastName]`).val();

    const address1 = $(`[name*=dwfrm_membership_${addressType}Address_address1]`).val();
    const address2 = $(`[name*=dwfrm_membership_${addressType}Address_address2]`).val();
    const city = $(`[name*=dwfrm_membership_${addressType}Address_city]`).val();
    const zipCode = $(`[name*=dwfrm_membership_${addressType}Address_postalCode]`).val();
    const phoneNumber = $(`[name*=dwfrm_membership_${addressType}Address_phone]`).val();
    const stateCode = $(`[name*=dwfrm_membership_${addressType}Address_states_stateCode]:enabled`).val();

    if (addressType === 'shipping') {
        if (shippingAddress) {
            $('.js-summary-delivery-name').text(`${shippingAddress.firstName}`);
            $('.js-summary-delivery-address').html(`${shippingAddress.address1}${shippingAddress.address2 ? `</br>${shippingAddress.address2}` : ''}<br/> ${shippingAddress.city}, ${shippingAddress.stateCode} ${shippingAddress.zipCode}<br/>${shippingAddress.phoneNumber ? shippingAddress.phoneNumber : ''}`);
        } else {
            $('.js-summary-delivery-name').text(`${firstName} ${lastName}`);
            $('.js-summary-delivery-address').html(`${address1}${address2 ? `</br>${address2}` : ''}<br/> ${city}, ${stateCode} ${zipCode}<br/>${phoneNumber}`);
        }

        $('.js-membership-summary-delivery').removeClass('d-none');
    } else {
        $('.js-summary-billing-name').text(`${firstName} ${lastName}`);
        $('.js-summary-billing-address').html(`${address1}${address2 ? `</br>${address2}` : ''}<br/> ${city}, ${stateCode} ${zipCode}<br/>${phoneNumber}`);

        $('.js-membership-summary-billing').removeClass('d-none');
    }
}

function copyShippingToBilling() {
    const $billingAddress = $('.js-billing-address');
    const $shippingAddress = $('.js-delivery-address');

    const formElements = formFields.concat(formSelect);
    formElements.forEach((item) => {
        $(item, $billingAddress).val(() => $(item, $shippingAddress).val());
    });

    $('.js-billing-country').trigger('change');
    $('.js-billing-email').trigger('change');
}

function displayMembershipStep(e) {
    e.preventDefault();
    $('.js-membership-step').addClass('d-none');
    $('.js-membership-step[data-step="1"]').removeClass('d-none');
}

function displayDeliveryStep(e) {
    e.preventDefault();

    const $form = $(this).closest('form');
    $.spinner().start();
    $.ajax({
        url: $form.data('submit-form'),
        type: 'POST',
        dataType: 'json',
        data: $form.serialize(),
    })
        .done((data) => {
            if (data.success) {
                $('.js-membership-step').addClass('d-none');
                $('.js-membership-step[data-step="2"]').removeClass('d-none');
            } else if (data.error) {
                $.spinner().stop();
                alert({ message: data.message, delay: 15000 });
                return;
            }
        })
        .always(() => {
            $.spinner().stop();
        });
}

function displayBillingStep(e) {
    e.preventDefault();

    const $form = $(this).closest('form');
    $.spinner().start();
    $.ajax({
        url: $form.data('submit-form'),
        type: 'POST',
        dataType: 'json',
        data: $form.serialize(),
    })
        .done(() => {
            $('.js-membership-step').addClass('d-none');
            $('.js-membership-step[data-step="3"]').removeClass('d-none');
        })
        .always(() => {
            $.spinner().stop();
        });
}

function validateDeliveryForm() {
    let valid = true;
    const isPickup = $('.js-membership-delivery-option .custom-control-input:checked').hasClass('pickup');
    if (!isPickup) {
        $('.js-delivery-address .required input, .js-delivery-address .required select').each(function () {
            const $formGroup = $(this).closest('.form-group');
            if (!this.checkValidity()) {
                $formGroup.removeClass('was-validated');
                valid = false;
            } else {
                $formGroup.find('.invalid-feedback').html('');
                $formGroup.addClass('was-validated');
            }
        });
    }

    return valid;
}

function validateBillingForm() {
    let valid = true;
    $('.js-billing-address .required input, .js-billing-address .required select').each(function () {
        const $formGroup = $(this).closest('.form-group');
        if (!this.checkValidity()) {
            $formGroup.removeClass('was-validated');
            valid = false;
        } else {
            $formGroup.find('.invalid-feedback').html('');
            $formGroup.addClass('was-validated');
        }
    });

    return valid;
}

function validateBillingAccountForm() {
    let valid = true;
    $('.js-billing-account .required input').each(function () {
        const $formGroup = $(this).closest('.form-group');
        if (!this.checkValidity()) {
            $formGroup.removeClass('was-validated');
            valid = false;
        } else {
            $formGroup.find('.invalid-feedback').html('');
            $formGroup.addClass('was-validated');
        }
    });

    return valid;
}

function validatePaymentForm() {
    let valid = true;
    $('.js-payment-information .required input, .js-payment-information .required select').each(function () {
        const $formGroup = $(this).closest('.form-group');
        if (!this.checkValidity()) {
            $formGroup.removeClass('was-validated');
            valid = false;
        } else {
            $formGroup.find('.invalid-feedback').html('');
            $formGroup.addClass('was-validated');
        }
    });

    return valid;
}

function removeFormValidation(formElement, errorFields) {
    Object.keys(errorFields).forEach((key) => {
        if (errorFields[key]) {
            const $parent = $(formElement).find(`[name="${key}"]`).parent();
            if ($parent.length > 0) {
                $parent.removeClass('was-validated');
            }
        }
    });
}

function submitSubscription(e) {
    e.preventDefault();
    $('.error-message').hide();
    const $form = $(this).closest('form');

    if (validateDeliveryForm() && validatePaymentForm()) {
        if ($('#terms-and-conditions')[0].checkValidity()) {
            $(this).attr('disabled', true);
            $.spinner().start();

            $.ajax({
                url: $form.attr('action'),
                type: 'POST',
                data: $form.serialize(),
                success: (data) => {
                    if (data.success) {
                        window.location.href = data.redirectUrl;
                    } else {
                        $(this).removeAttr('disabled');
                        $.spinner().stop();

                        $('.error-message').show();
                        $('.error-message-text').text(data.error);
                        scrollAnimate($('.error-message'));
                        if (data.csrf) {
                            $('.js-csrf-token').val(data.csrf.token);
                            $('.js-csrf-token').attr('name', data.csrf.tokenName);
                        }
                    }
                },
                error: () => {
                    $(this).removeAttr('disabled');
                    $.spinner().stop();
                },
            });
        }
    }
}

function submitDeliveryStep(e) {
    e.preventDefault();

    if (!validateDeliveryForm()) {
        return displayDeliveryStep(e);
    }

    const $form = $(this).closest('form');
    $.spinner().start();

    if (!$(this).hasClass('js-address-verified')) {
        const verifyAddressUrl = $(this).data('url-verify');
        const addressInputName = 'membership_shippingAddress';
        validateAddress.verifyAddress(verifyAddressUrl, $form, $form.serialize(), addressInputName);
    } else {
        $.ajax({
            url: $(this).data('url'),
            type: 'POST',
            dataType: 'json',
            data: $form.serialize(),
        })
            .done((data) => {
                $('.error-message').hide();
                if (data.errorMsg) {
                    if ($('.error-message').length > 0) {
                        $('.error-message').show();
                        $('.error-message-text').text(data.errorMsg);
                    } else {
                        const errorHtml = `<div class="alert alert-danger alert-dismissible 
                            fade show" role="alert">
                            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>${data.errorMsg}</div>`;
                        $('.membership-error').html(errorHtml);
                    }
                    scrollAnimate($('.error-message'));
                } else {
                    updateSummaryAddress('shipping', data.shippingAddress);
                    if ($('.js-billing-same-shipping').is(':checked')) {
                        copyShippingToBilling();
                    }
                    $('.js-membership-step').addClass('d-none');
                    $('.js-membership-step[data-step="3"]').removeClass('d-none');
                }
            })
            .always(() => {
                $('.js-submit-address').removeClass('js-address-verified');
                $.spinner().stop();
            });
    }
}

function submitBillingStep(e) {
    e.preventDefault();

    if (!validateBillingForm()) {
        return displayBillingStep(e);
    }

    if (!$('.js-billing-account').hasClass('d-none') && !validateBillingAccountForm()) {
        return displayBillingStep(e);
    }

    const $form = $(this).closest('form');
    $.spinner().start();

    $.ajax({
        url: $(this).data('url'),
        type: 'POST',
        dataType: 'json',
        data: $form.serialize(),
    })
        .done((data) => {
            if (data.success) {
                if (data.removePasswords) {
                    removePasswordFields();
                }
                updateSummaryAddress('billing');
                $('.js-membership-step').addClass('d-none');
                $('.js-membership-step[data-step="4"]').removeClass('d-none');
            } else if (data.displayPasswords) {
                if (data.customerEmail) {
                    $('.js-customer-email').html(data.customerEmail);
                }
                if (data.existingCustomer) {
                    $('.js-passwordconfirm').addClass('d-none');
                    $('.js-password-constraints').addClass('d-none');
                    $('.js-billing-account').removeClass('d-none');
                    $('.js-guest-disclaimer').addClass('d-none');
                    $('.js-registered-disclaimer').removeClass('d-none');
                    $('#passwordconfirm').attr('disabled', true);
                } else {
                    $('.js-passwordconfirm').removeClass('d-none');
                    $('.js-password-constraints').removeClass('d-none');
                    $('.js-billing-account').removeClass('d-none');
                    $('.js-guest-disclaimer').removeClass('d-none');
                    $('.js-registered-disclaimer').removeClass('d-none');
                    $('#passwordconfirm').removeAttr('disabled');
                }
            } else if (data.error) {
                $.spinner().stop();
                alert({ message: data.message, delay: 15000 });
            } else {
                removeFormValidation($form, data.fields);
                formValidation($form, data);
            }
        })
        .always(() => {
            $.spinner().stop();
        });
}

function handleOpenRemoveModal(event) {
    const $button = $(event.relatedTarget);
    const pid = $button.data('pid');
    const name = $button.data('product-name');

    $(this).data('pid', pid);
    if (name) {
        $(this).find('.js-modal-title').html(`Remove ${name}`);
    }
}

function handleClickProceedRemove() {
    const $this = $(this);
    const actionUrl = $this.data('action');
    const $modal = $this.closest('.modal');
    const pid = $modal.data('pid');

    $modal.spinner().start();
    $.ajax({
        url: actionUrl,
        type: 'POST',
        dataType: 'json',
        data: `pid=${pid}`,
    })
        .done((r) => {
            const alertArgs = { message: r.message };

            if (r && r.success) {
                window.location.reload();
            } else {
                alert(alertArgs);
            }
        })
        .fail((xhr, textStatus) => {
            alert({ message: xhr.message || textStatus });
        })
        .always(() => {
            $modal.modal('hide');
            $modal.spinner().stop();
        });
}

function handleOpenSkipModal() {
    const autoShipId = $(this).data('autoship-id');
    $(`#makeChangesModal${autoShipId}`).modal('hide');
}

function handleCloseCancelModal() {
    $('.js-membership-cancel-reason').val('');
    $('.js-cancel-reason-other').addClass('d-none');
    $('.js-cancel-reason-other').val('');
}

function handleClickCancelRemove() {
    const autoShipId = $(this).closest('.modal').data('autoship-id');
    $(`#removeProductModal${autoShipId}`).modal('hide');
    $(`#makeChangesModal${autoShipId}`).modal('show');
}

function handleClickCancelSkip() {
    const autoShipId = $(this).closest('.modal').data('autoship-id');
    $(`#skipShipmentModal${autoShipId}`).modal('hide');
    $(`#makeChangesModal${autoShipId}`).modal('show');
}

function handleClickCancelSkip2() {
    $('#skipShipmentModalV2').modal('hide');
}

function handleClickCancelChangeShipmentDate() {
    const autoShipId = $(this).closest('.modal').data('autoship-id');
    $(`#changeShipmentDateModal${autoShipId}`).modal('hide');
    $(`#makeChangesModal${autoShipId}`).modal('show');
}

function handleClickProceedSkip() {
    const $this = $(this);
    const actionUrl = $this.data('action');
    const $modal = $this.closest('.modal');

    $modal.spinner().start();
    $.ajax({
        url: actionUrl,
        type: 'POST',
        dataType: 'json',
    })
        .done((r) => {
            const alertArgs = { message: r.message };

            if (r && r.success) {
                $('#nav-upcoming').hide();
                $('#skipShipmentBtn').hide();
                alert(alertArgs);
            } else {
                alert(alertArgs);
            }
        })
        .fail((xhr, textStatus) => {
            alert({ message: xhr.message || textStatus });
        })
        .always(() => {
            $modal.modal('hide');
            $modal.spinner().stop();
        });
}

function handleClickProceedChangeShipmentDate() {
    const $this = $(this);
    const actionUrl = $this.data('action');
    const $modal = $this.closest('.modal');
    const autoshipId = $modal.data('autoship-id');

    const $shipmentDate = $modal.find('.js-shipment-date');

    if ($shipmentDate.val()) {
        const changeShipmentData = {
            autoshipId,
            shipmentDate: $shipmentDate.val(),
        };

        $modal.spinner().start();
        $.ajax({
            url: actionUrl,
            type: 'POST',
            dataType: 'json',
            data: changeShipmentData,
        })
            .done((r) => {
                const alertArgs = { message: r.message };

                if (r && r.success) {
                    $modal.modal('hide');
                    window.location.href = r.redirectUrl;
                } else {
                    alert(alertArgs);
                }
            })
            .fail((xhr, textStatus) => {
                alert({ message: xhr.message || textStatus });
            })
            .always(() => {
                $modal.spinner().stop();
            });
    }
}

function handleClickCancelPause() {
    $('div[id^=pauseMembershipModal]').modal('hide');
}

function handleClickCancelCancelation() {
    $('div[id^=cancelMembershipModal]').modal('hide');
}

function handleClickCancelActivate() {
    $('div[id^=activateMembershipModal]').modal('hide');
}

function handleClickCancelSwapMembership() {
    $('div[id^=swapMembershipModal]').modal('hide');
}

function handleClickProceedMembershipActivate() {
    const $this = $(this);
    const actionUrl = $this.data('action');
    const $modal = $this.closest('.modal');

    $modal.spinner().start();
    $.ajax({
        url: actionUrl,
        type: 'POST',
        dataType: 'json',
    })
        .done((data) => {
            const alertArgs = { message: data.message };

            if (data.redirectUrl) {
                window.location.href = data.redirectUrl;
            } else {
                alert(alertArgs);
            }
        })
        .fail((xhr, textStatus) => {
            alert({ message: xhr.message || textStatus });
        })
        .always(() => {
            $modal.modal('hide');
            $modal.spinner().stop();
        });
}

function handleClickProceedMembershipCancel() {
    const $this = $(this);
    const actionUrl = $this.data('action');
    const $modal = $this.closest('.modal');
    const $cancelReason = $modal.find('.js-membership-cancel-reason');
    $cancelReason.removeClass('is-invalid');

    if ($cancelReason.val()) {
        const cancelData = {
            cancelReason: $cancelReason.val(),
            cancelReasonOther: '',
        };
        if ($cancelReason.val() === 'Other') {
            cancelData.cancelReasonOther = $modal.find('.js-cancel-reason-other').val();
        }

        $modal.spinner().start();
        $.ajax({
            url: actionUrl,
            type: 'POST',
            dataType: 'json',
            data: cancelData,
        })
            .done((data) => {
                const alertArgs = { message: data.message };

                if (data.redirectUrl) {
                    window.location.href = data.redirectUrl;
                } else {
                    alert(alertArgs);
                }
            })
            .fail((xhr, textStatus) => {
                alert({ message: xhr.message || textStatus });
            })
            .always(() => {
                $modal.modal('hide');
                $modal.spinner().stop();
            });
    } else {
        $cancelReason.addClass('is-invalid');
    }
}

function handleClickProceedMembershipPause() {
    const $this = $(this);
    const actionUrl = $this.data('action');
    const $modal = $this.closest('.modal');
    const $pauseDuration = $modal.find('.js-membership-pause-select');
    $pauseDuration.removeClass('is-invalid');

    if ($pauseDuration.val()) {
        const pauseData = {
            pauseDuration: $pauseDuration.val(),
        };

        $modal.spinner().start();
        $.ajax({
            url: actionUrl,
            type: 'POST',
            dataType: 'json',
            data: pauseData,
        })
            .done((data) => {
                const alertArgs = { message: data.message };

                if (data.redirectUrl) {
                    window.location.href = data.redirectUrl;
                } else {
                    alert(alertArgs);
                }
            })
            .fail((xhr, textStatus) => {
                alert({ message: xhr.message || textStatus });
            })
            .always(() => {
                $modal.modal('hide');
                $modal.spinner().stop();
            });
    } else {
        $pauseDuration.addClass('is-invalid');
    }
}

function handleClickProceedMembershipSwap() {
    const $this = $(this);
    const actionUrl = $this.data('action');
    const $modal = $this.closest('.modal');
    const $membershipSwapSelect = $modal.find('.js-membership-swap-select');
    $membershipSwapSelect.removeClass('is-invalid');

    if ($membershipSwapSelect.val()) {
        $modal.spinner().start();
        $.ajax({
            url: actionUrl,
            type: 'POST',
            dataType: 'json',
            data: `clubIdSwap=${$membershipSwapSelect.val()}`,
        })
            .done((r) => {
                const alertArgs = { message: r.message };

                if (r && r.redirectUrl) {
                    window.location.href = r.redirectUrl;
                } else {
                    alert(alertArgs);
                }
            })
            .fail((xhr, textStatus) => {
                alert({ message: xhr.message || textStatus });
            })
            .always(() => {
                $modal.modal('hide');
                $modal.spinner().stop();
            });
    } else {
        $membershipSwapSelect.addClass('is-invalid');
    }
}

function handleCloseModal() {
    $(this).closest('.modal').modal('hide');
}

function handleClickProceedSwitchPickup() {
    const $this = $(this);
    const actionUrl = $this.data('action');
    const $modal = $this.closest('.modal');
    const autoshipId = $modal.data('autoship-id');

    $modal.spinner().start();
    $.ajax({
        url: actionUrl,
        type: 'POST',
        dataType: 'json',
        data: `autoshipID=${autoshipId}`,
    })
        .done(() => {
            window.location.reload();
        })
        .fail((xhr, textStatus) => {
            alert({ message: xhr.message || textStatus });
        })
        .always(() => {
            $modal.modal('hide');
            $modal.spinner().stop();
        });
}

function initRecommendationCarousel() {
    $('.membership-add .membership-recommendation').each((i, el) => {
        const $slider = $(el);

        $slider.slick({
            mobileFirst: true,
            dots: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: '<div class="arrow__container arrow__container--prev"><span class="arrow__diamond"></span><button type="button" class="slick-prev">Previous</button></div>',
            nextArrow: '<div class="arrow__container arrow__container--next"><span class="arrow__diamond"></span><button type="button" class="slick-next">Next</button></div>',
            responsive: [
                {
                    breakpoint: breakpoints.sm,
                    settings: {
                        slidesToShow: 2,
                    },
                },
                {
                    breakpoint: breakpoints.md,
                    settings: {
                        slidesToShow: 3,
                    },
                },
                {
                    breakpoint: breakpoints.xl,
                    settings: {
                        slidesToShow: 4,
                    },
                },
            ],
        });

        carouselAnimations.animateArrows($slider);
    });

    $('.membership-swap .membership-recommendation').each((i, el) => {
        const $slider = $(el);

        $slider.slick({
            mobileFirst: true,
            dots: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: '<div class="arrow__container arrow__container--prev"><span class="arrow__diamond"></span><button type="button" class="slick-prev">Previous</button></div>',
            nextArrow: '<div class="arrow__container arrow__container--next"><span class="arrow__diamond"></span><button type="button" class="slick-next">Next</button></div>',
            responsive: [
                {
                    breakpoint: breakpoints.xs,
                    settings: 'unslick',
                },
                {
                    breakpoint: breakpoints.md,
                    settings: {
                        slidesToShow: 1,
                    },
                },
                {
                    breakpoint: breakpoints.xl,
                    settings: {
                        slidesToShow: 2,
                    },
                },
                {
                    breakpoint: 1300,
                    settings: {
                        slidesToShow: 3,
                    },
                },
            ],
        });

        carouselAnimations.animateArrows($slider);
    });
}

function handleMethodsOptionsChange(e) {
    const $checkbox = $(e.currentTarget);
    const $option = $checkbox.closest('.js-membership-delivery-option');
    const $body = $option.find('.js-membership-delivery-option-body');
    const $allOptions = $('.js-membership-delivery-option');
    const $allCheckboxes = $allOptions.find('.custom-control-input');
    const $allOptionsBody = $allOptions.find('.js-membership-delivery-option-body');

    $allOptions.removeClass('active');
    $allCheckboxes.prop('checked', false);
    $allOptionsBody.not($body).slideUp();

    $option.addClass('active');
    $checkbox.prop('checked', true);

    if ($body.length) {
        $body.slideDown();
    }

    if ($checkbox.hasClass('pickup')) {
        $('.membership-delivery__address-form').hide();
    } else {
        $('.membership-delivery__address-form').show();
    }
}

function showScheduleInformation(contentUrl) {
    const $content = $('.js-membership-schedule');

    $.ajax({
        url: contentUrl,
        dataType: 'html',
    })
        .done((data) => {
            $content.html(data);
        })
        .fail(() => {
            $content.empty();
        });
}

function displayClubInfo(selectedOption) {
    const wineClubClass = `.js-club-${selectedOption.val()}`;

    $('.js-club-info').addClass('d-none');
    $(wineClubClass).removeClass('d-none');
    showScheduleInformation(selectedOption.data('content'));
}

function handleClubChange() {
    const selectedOption = $('option:selected', this);

    displayClubInfo(selectedOption);
    updateClubHiddenInputs();
    updateSummaryPackMessage();
}

function clearForm($form) {
    if (!$form) return;

    formFields.forEach((item) => {
        $(item, $form).val('');
    });

    formSelect.forEach((item) => {
        $(item, $form).prop('selectedIndex', 0);
    });
}

function handleBillingAddress() {
    if ($(this).is(':checked')) {
        copyShippingToBilling();
    } else {
        clearForm($('.js-billing-address'));
    }
}

function handleProductQuantityChange() {
    const $this = $(this);
    const actionUrl = $this.data('url');
    const autoshipID = $this.data('autoship-id');
    const pid = $this.data('pid');
    const qty = $this.val();

    const urlParams = {
        autoshipID,
        pid,
        qty,
    };

    if (qty) {
        $.spinner().start();
        $.ajax({
            url: actionUrl,
            type: 'POST',
            dataType: 'json',
            data: urlParams,
        })
            .done((data) => {
                if (data.success) {
                    alert({
                        context: 'alert-success',
                        dismissible: false,
                        message: data.message,
                        delay: 5000,
                    });
                } else {
                    alert({ message: data.message });
                }
            })
            .fail((xhr, textStatus) => {
                $.spinner().stop();
                alert({ message: xhr.message || textStatus });
            }).always(() => {
                $.spinner().stop();
            });
    }
}

function handleCancelReasonChange() {
    const $cancelReasonOther = $('.js-cancel-reason-other');
    if ($(this).val() === 'Other') {
        $cancelReasonOther.removeClass('d-none');
    } else {
        $cancelReasonOther.addClass('d-none');
        $cancelReasonOther.val('');
    }
}

function onBillingCountrySelect() {
    const $usBillingState = $('.js-billig-state-us');
    const $caBillingState = $('.js-billig-state-ca');

    if ($(this).val() === 'CA') {
        $usBillingState.addClass('d-none');
        $usBillingState.val('');
        $usBillingState.attr('disabled', true);

        $caBillingState.removeClass('d-none');
        $caBillingState.removeAttr('disabled');
    } else {
        $caBillingState.addClass('d-none');
        $caBillingState.val('');
        $caBillingState.attr('disabled', true);

        $usBillingState.removeClass('d-none');
        $usBillingState.removeAttr('disabled');
    }
}

function onMembershipActionSelect() {
    $(this).removeClass('is-invalid');
}

function handleLocalDates() {
    const options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        timeZone: 'America/Los_Angeles',
    };

    const $fulfillmentDateGMT = $('.js-raw-fulfillment-date');
    $fulfillmentDateGMT.each((i, $el) => {
        if ($el.value) {
            const fulfillmentDate = new Date($el.value);
            fulfillmentDate.setDate(fulfillmentDate.getDate() - 1);
            const fulfillmentDatePST = fulfillmentDate.toLocaleDateString('en-US', options);
            $($el).closest('.autoshipment-header').find('.js-next-order-date').html(fulfillmentDatePST);
        }
    });

    const $freezeDateGMT = $('.js-raw-freeze-date');
    $freezeDateGMT.each((i, $el) => {
        if ($el.value) {
            const freezeDatePST = new Date($el.value).toLocaleDateString('en-US', options);
            $($el).closest('.autoshipment-header').find('.js-freeze-date').html(freezeDatePST);
        }
    });

    const $shippingDateGMT = $('.js-raw-shipping-date');
    $shippingDateGMT.each((i, $el) => {
        if ($el.value) {
            const shippingDatePST = new Date($el.value).toLocaleDateString('en-US', options);
            $($el).closest('.autoshipment-header').find('.js-shipping-date').html(shippingDatePST);
        }
    });
}

function calculateAutoshipPrices() {
    const url = $('.js-calculate-prices').val();

    if (url) {
        $.spinner().start();

        $.ajax({
            url,
            type: 'GET',
            dataType: 'json',
        })
            .done((data) => {
                if (data.success && data.upcomingAutoshipments && data.upcomingAutoshipments.length > 0) {
                    data.upcomingAutoshipments.forEach((shipment) => {
                        if (shipment.orderTotal) {
                            $(`.js-autoship-header-${shipment.autoshipID}`).find('.js-autoship-total-price').html(shipment.orderTotal);
                        }
                    });
                }
            })
            .always(() => {
                $.spinner().stop();
            });
    }
}

function checkAutoshipProductQuanities() {
    $('.js-update-max-quantity').each(function () {
        $(this).removeClass('js-update-max-quantity');
        $(this).trigger('change');
    });
}

function handleTermsAndConditions() {
    if ($(this).is(':checked')) {
        $('#wcTermsConditionsModal').modal('show');
        $('.js-submit-payment').removeAttr('disabled');
    } else {
        $('.js-submit-payment').attr('disabled', true);
        $('#wcTermsConditionsModal').modal('hide');
    }
}

function handleCreditCardNumber() {
    if ($('.cardNumber').length && $('#cardType').length) {
        cleave.handleCreditCardNumber('.cardNumber', '#cardType');
    }
}

function handleBulkPlaceOrder(e) {
    e.preventDefault();

    $('.bulkOrder-submit').attr('disabled', true);

    $.ajax({
        url: $(this).attr('action'),
        method: 'POST',
        data: $(this).serialize(),
        success: function (response) {
            $('.bulkOrder-submit').attr('disabled', false);
            if (response.serverErrors) {
                alert({
                    context: 'alert-danger',
                    dismissible: true,
                    message: response.serverErrors,
                });
            } else {
                window.location.href = response.redirectUrl;
            }
        },
        error: function (error) {
            $('.bulkOrder-submit').attr('disabled', false);
            // Handle any unexpected errors
            alert({
                context: 'alert-danger',
                dismissible: true,
                message: 'Error',
            });
        }
    });
}

function showCustomizeCondition() {
    window.localStorage.setItem('isCustomizeOrder', true);
}

function bindEvents() {
    // Membership Page (Join Flow) Events
    $(document)
        .on('click', '.js-bottles-option', checkOption)
        .on('change', '.js-bottles-option input:radio', handleBottles)
        .on('click', '.js-edit-membership', displayMembershipStep)
        .on('click', '.js-next-delivery, .js-edit-delivery', displayDeliveryStep)
        .on('click', '.js-next-billing', submitDeliveryStep)
        .on('click', '.js-edit-billing', displayBillingStep)
        .on('click', '.js-next-payment', submitBillingStep)
        .on('blur', '.js-delivery-address .required input, .js-delivery-address .required select', validateDeliveryForm)
        .on('blur', '.js-billing-address .required input, .js-billing-address .required select', validateBillingForm)
        .on('blur', '.js-billing-account .required input', validateBillingAccountForm)
        .on('change', '.js-billing-email', displayPasswordFields)
        .on('blur', '.js-payment-information .required input, .js-payment-information .required select', validatePaymentForm)
        .on('click', '.js-submit-payment', submitSubscription)
        .on('change', '.js-membership-delivery-option .custom-control-input', handleMethodsOptionsChange)
        .on('change', '.js-club-select', handleClubChange)
        .on('change', '.js-billing-same-shipping', handleBillingAddress)
        .on('change', '.js-update-product-quantity', handleProductQuantityChange)
        .on('change', '.js-membership-cancel-reason', handleCancelReasonChange)
        .on('change', '.js-billing-country', onBillingCountrySelect)
        .on('change', '.js-membership-swap-select, .js-membership-cancel-reason, .js-membership-pause-select', onMembershipActionSelect)
        .on('click', '.cardNumber', handleCreditCardNumber)
        .on('submit', '#bulkOrderForm', handleBulkPlaceOrder);

    const clubSelectedOption = $('.js-club-select option:selected');
    displayClubInfo(clubSelectedOption);
    $('.error-message').hide();

    updateClubHiddenInputs();
    updateSummaryPackMessage();

    // Remove Product Modal
    $('.js-remove-modal').on('show.bs.modal', handleOpenRemoveModal);
    $('.js-remove-proceed').on('click', handleClickProceedRemove);
    $('.js-remove-cancel').on('click', handleClickCancelRemove);

    // Skip Autoship Events
    $('.js-skip-modal').on('show.bs.modal', handleOpenSkipModal);
    $('.js-skip-cancel').on('click', handleClickCancelSkip);
    $('.js-skip-cancel2').on('click', handleClickCancelSkip2);
    $('.js-skip-proceed').on('click', handleClickProceedSkip);

    // Change Shipment Date Events
    $('.js-change-shipment-modal').on('show.bs.modal', handleOpenSkipModal);
    $('.js-change-shipment-cancel').on('click', handleClickCancelChangeShipmentDate);
    $('.js-change-shipment-proceed').on('click', handleClickProceedChangeShipmentDate);

    // Pause/Activate/Cancel Autoship Events
    $('.js-cancel-modal').on('hidden.bs.modal', handleCloseCancelModal);
    $('.js-pause-cancel').on('click', handleClickCancelPause);
    $('.js-cancelation-cancel').on('click', handleClickCancelCancelation);
    $('.js-activate-cancel').on('click', handleClickCancelActivate);
    $('.js-activate-proceed').on('click', handleClickProceedMembershipActivate);
    $('.js-pause-proceed').on('click', handleClickProceedMembershipPause);
    $('.js-cancel-proceed').on('click', handleClickProceedMembershipCancel);

    // Swap Membership Events
    $('.js-swap-membership-cancel').on('click', handleClickCancelSwapMembership);
    $('.js-swap-membership-proceed').on('click', handleClickProceedMembershipSwap);

    // Switch To Pickup Events
    $('.js-switch-pickup-cancel').on('click', handleCloseModal);
    $('.js-switch-pickup-proceed').on('click', handleClickProceedSwitchPickup);
    $('#terms-and-conditions').on('click', handleTermsAndConditions);

    // Autoship Recommendation Events
    initRecommendationCarousel();

    // show customize condition
    $('.customize-order').on('click', showCustomizeCondition);
}

$(document).ready(() => {
    const $displayMessage = $('.js-display-message');
    if ($displayMessage.length > 0 && $displayMessage.val()) {
        alert({
            context: 'alert-success',
            dismissible: false,
            message: $displayMessage.val(),
            delay: 5000,
        });
    }
});

// validate draft order
$(document).ready(() => {
    // get all values when click on confirm button
    $('.confirm-order').click(function () {
        $.spinner().start();
        const actionURL = $(this).data('action');
        // create Ajax call
        $.ajax({
            url: actionURL,
            type: 'POST',
            dataType: 'json',
            success: (data) => {
                if (data.success === false) {
                    $.spinner().stop();
                    // show error message
                    if (data.error === true && data.message) {
                        alert({
                            message: data.message,
                            delay: 15000
                        });
                    }
                }
                else {
                    $.spinner().stop();
                    alert({
                        context: 'alert-success',
                        dismissible: false,
                        message: data.message,
                        delay: 5000,
                    });
                    // reload the page
                    setTimeout(() => {
                        window.location.reload();
                    }, 5000);
                }
            },
        });
    });
});
module.exports = {
    handleLocalDates,
    calculateAutoshipPrices,
    bindEvents,
    checkAutoshipProductQuanities,
};
